import { MountedRelationalDatabaseTableDataset, Metamodel, IAttribute } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularCopySink } from './tabular.copysink';

@Metamodel.model({
    name: adfModelTypeMap.mountedRelationalDatabase.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(MountedRelationalDatabaseTableDataset) }
})
export class MountedRelationalDatabaseTableCopySink extends TabularCopySink {
    public static readonly WRITE_BEHAVIOR_KEYS: IAttribute;
    public static readonly DEFAULT_ROW_MARKER: IAttribute;
    public static readonly ROW_MARKER_COLUMN: IAttribute;
    public static readonly OPERATION_TYPE: IAttribute;
    public static readonly TABLE_NAME: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR_KEYS',
        display: stringResources.DataFlowDatasetKeyColumns,
        accepts: ['Array', 'Object']
    })
    public writeBehaviorKeys?: string[];

    @Metamodel.attribute({
        templatable: true,
        association: 'DEFAULT_ROW_MARKER',
        display: stringResources.DefaultRowMarker
    })
    public defaultRowMarker?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'ROW_MARKER_COLUMN',
        display: stringResources.RowMarkerColumn
    })
    public rowMarkerColumn?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'OPERATION_TYPE',
        display: stringResources.OperationType
    })
    public operationType?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'TABLE_NAME',
        display: stringResources.Table_name_Label
    })
    public tableName?: string;
}
